import {Injectable} from '@angular/core';
import {HttpProvider} from "../../providers/http/http";

/*
  Generated class for the PullProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PullProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello PullProvider Provider');
  }

  getEvents(){
    let params = {
      page:1,
      pagesize:1000000
    };
    return this.http.hPost('/acquisition/get_list',params);
  }

}



// WEBPACK FOOTER //
// ./src/pages/pull/pull.ts